<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="650"
      max-height="90%"
      min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t("sites.add_site") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin" :loading="savingInProgress">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="site_form">
          <v-container fluid>
            <v-row align="center">
              <v-col
                  class="d-flex"
                  sm="12"
              >
                <v-text-field
                    prefix="https://"
                    v-model="tmpSite.domain"
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin" small :loading="savingInProgress">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn small
            class="white--text"
            elevation="0"
            color="success"
            @click="store"
            :loading="savingInProgress"
        >
          {{ $t("sites.add_site") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "SiteWindow",
  props: {
    site: null,
    savingInProgress: false,
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tmpSite:{
      domain:null,
      protocol: "https://"
    }
  }),
  computed:{
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods:{
    store(){
      if (this.$refs['site_form'].validate()) {
        this.$emit('store', this.tmpSite)
      }
    },
    hideWin() {
      this.isVisibleWindow = false;
      this.tmpSite.domain = null;
      this.tmpSite.protocol = "https://";
    },
  },
  watch:{
    isVisible(to){
      if(to){
        this.tmpSite.domain = null;
        if(this.$refs['site_form']) {
          this.$refs['site_form'].resetValidation()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>